import { createAction } from 'redux-actions';
import { actionKey } from './constants';
export var initialize = createAction(actionKey + "/INITIALIZE");
export var updateCommentsOrder = createAction(actionKey + "/UPDATE_COMMENT_ORDER", function (order) { return ({ order: order }); });
export var updateCommentsOrderDone = createAction(actionKey + "/UPDATE_COMMENT_ORDER_DONE", function (order) { return ({ order: order }); });
export var toggleTheme = createAction(actionKey + "/TOGGLE_THEME");
export var toggleThemeDone = createAction(actionKey + "/TOGGLE_THEME_DONE");
export var setTheme = createAction(actionKey + "/SET_THEME", function (theme) { return ({
    theme: theme,
}); });
export var toggleMature = createAction(actionKey + "/TOGGLE_MATURE", function (current) { return ({ current: current }); });
export var switchVersion = createAction(actionKey + "/SWITCH_VERSION");
export var resendVerificationEmail = createAction(actionKey + "/RESEND_VERIFICATION_EMAIL");
export var resendVerificationEmailSuccess = createAction(actionKey + "/RESEND_VERIFICATION_EMAIL/SUCCESS");
export var resendVerificationEmailFail = createAction(actionKey + "/RESEND_VERIFICATION_EMAIL/FAIL");
export var updateEmail = createAction(actionKey + "/UPDATE_EMAIL", function (email) { return ({ email: email }); });
export var updateEmailSuccess = createAction(actionKey + "/UPDATE_EMAIL/SUCCESS", function (email) { return ({ email: email }); });
export var updateEmailFail = createAction(actionKey + "/UPDATE_EMAIL/FAIL", function (email) { return ({ email: email }); });
export var setViewMode = createAction(actionKey + ".SET_VIEW_MODE", function (viewMode) { return viewMode; });
export var setIsMobile = createAction(actionKey + "/SET_MOBILE", function (isMobile) { return ({
    isMobile: isMobile,
}); });
//# sourceMappingURL=actions.js.map